﻿namespace WebPortal.WebPortalTour {
    interface ITourController {
        start(): void;
        restart(): void;
    }

    export abstract class TourController implements ITourController {
        private Tour: any = null;

        constructor(_TourName: string) {
            let UserSettings: any = null;
            if ($("#hdf_settings").val() != "") {
                UserSettings = JSON.parse($("#hdf_settings").val());
            }
            if (!!UserSettings && !!UserSettings.Language_ID) {
                this.init(UserSettings.Language_ID, _TourName);
            } else {
                this.init(0, _TourName);
            }
        }

        private init(_Language: number, _TourName: string): void {
            this.Tour = new Tour({
                "name": _TourName,
                "backdrop": true,
                //"debug": true
            });

            let DefaultTourSteps: any[] = null;
            switch (_Language) {
                // Deutsch
                case 2:
                    DefaultTourSteps = this.getGermanSteps();
                    break;
                // Französisch
                case 3:
                    DefaultTourSteps = this.getFrenchSteps();
                    break;
                // Italienisch
                case 5:
                    DefaultTourSteps = this.getItalianSteps();
                    break;
                // alle anderen Englisch
                default:
                    DefaultTourSteps = this.getEnglishSteps();
            }
            this.Tour.addSteps(DefaultTourSteps);
        }

        public start(): void {
            console.info("Tour.start");
            this.Tour.init();
            this.Tour.start(false);
        }

        public restart(): void {
            console.info("Tour.restart");
            this.Tour.start(true);
            this.Tour.goTo(0);
        }

        protected abstract getGermanSteps(): any[];
        protected abstract getFrenchSteps(): any[];
        protected abstract getItalianSteps(): any[];
        protected abstract getEnglishSteps(): any[];
    }
}